import React, { Component } from "react";

class ClientSection extends Component {
  state = {};
  render() {
    return (
      <section id="clients-section">
        <div className="container client-row">
          <div className="row">
            <div className="col-md-4">
              <p className="head-top-desc">What Clients Speak</p>
              <h2 className="my-h2-head mb-md-4">
                Our client opinion matters a lot
              </h2>
              <p className="desc">
                Lorem Ipsum available, but the majority have suffered. All the
                Lorem Ipsum generators on the Internet tend to repeat
                predefined.
              </p>
            </div>
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-5 pt-4 pb-4 pl-4 pr-4 testimonials my-mt-sm-3">
                  <p>
                    "There are many variations of lorem spa ssages of Lorem
                    Ipsum lora available internet tend to repeat predefined.
                    Lorem Ipsum lora available internet tend to repeat
                    predefined lora go."
                  </p>
                  <div className="row pt-5">
                    <div className="col-3">
                      <img
                        className="img-fluid"
                        src={require("../../../static/images/testmonial-1.png")}
                        alt=""
                      />
                    </div>
                    <div className="col-9">
                      <h4 className="testimony-name">Jhon Doe</h4>
                      <p className="testimony-designation">CEO</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-5 pt-4 pb-4 pl-4 pr-4 testimonials my-mt-sm-3">
                  <p>
                    "There are many variations of lorem spa ssages of Lorem
                    Ipsum lora available internet tend to repeat predefined.
                    Lorem Ipsum lora available internet tend to repeat
                    predefined lora go."
                  </p>
                  <div className="row pt-5">
                    <div className="col-3">
                      <img
                        className="img-fluid"
                        src={require("../../../static/images/testmonial-1.png")}
                        alt=""
                      />
                    </div>
                    <div className="col-9">
                      <h4 className="testimony-name">Jhon Doe</h4>
                      <p className="testimony-designation">CEO</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ClientSection;
